import { Card } from "@/components/ui/card";

import type { OverviewOut, SignalOut } from "../api";
import { AlertsTab } from "./AlertsTab";

/** The daily read (jrae 2026-08-20): a short message about issues at ANY
 *  level, three level cards — an integration can break at the partner, the
 *  company (credentials), or the location (per-location files) — and the
 *  alerts worklist itself. Depth lives in the level tabs. */
export function OverviewTab({
  data,
  onOpenIncident,
  onOpenSignal,
  onGoTab,
}: {
  data: OverviewOut;
  onOpenIncident: (id: string, presetFlag?: boolean) => void;
  onOpenSignal: (s: SignalOut) => void;
  onGoTab: (tab: string) => void;
}) {
  const totalOpen = data.l1_open + data.l2_open + data.l3_open;
  return (
    <div className="flex flex-col gap-4">
      <Card className="p-4">
        <p className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          Today{data.digest_run_date ? ` — ${data.digest_run_date}` : ""}
        </p>
        <p className="whitespace-pre-line text-sm">
          {data.digest ??
            (totalOpen === 0
              ? "No open incidents at any level."
              : `${totalOpen} open incident${totalOpen === 1 ? "" : "s"} across the levels below.`)}
        </p>
      </Card>

      <div className="grid gap-3 md:grid-cols-3">
        <LevelCard
          title="Integration"
          sub="Partner stops delivering or misses a run"
          count={data.l1_open}
          extra={`${data.delivering_late} delivering late · ${data.dormant} dormant`}
          onClick={() => onGoTab("integrations")}
        />
        <LevelCard
          title="Company"
          sub="Broken credentials — no data for one company"
          count={data.l2_open}
          onClick={() => onGoTab("companies")}
        />
        <LevelCard
          title="Location"
          sub="Per-location files stop inside a nightly batch"
          count={data.l3_open}
          onClick={() => onGoTab("locations")}
        />
      </div>

      <AlertsTab onOpenIncident={onOpenIncident} onOpenSignal={onOpenSignal} />
    </div>
  );
}

function LevelCard({
  title,
  sub,
  count,
  extra,
  onClick,
}: {
  title: string;
  sub: string;
  count: number;
  extra?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-lg border bg-card p-4 text-left transition-colors hover:bg-muted"
    >
      <div className="flex items-baseline justify-between">
        <span className="text-sm font-semibold">{title}</span>
        <span
          className={`text-2xl font-bold tabular-nums ${
            count > 0 ? "text-destructive" : "text-success"
          }`}
        >
          {count}
        </span>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">{sub}</p>
      {extra && <p className="mt-1 text-xs text-muted-foreground">{extra}</p>}
    </button>
  );
}
